import { render } from "./SignUp.vue?vue&type=template&id=a6b901b8&scoped=true&ts=true"
import script from "./SignUp.vue?vue&type=script&lang=ts"
export * from "./SignUp.vue?vue&type=script&lang=ts"

import "./SignUp.vue?vue&type=style&index=0&id=a6b901b8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6b901b8"]])

export default __exports__